// extracted by mini-css-extract-plugin
export default {"label":"ForecastDivider_label__ksjkT","wrapper":"ForecastDivider_wrapper__t-t16"};